// extracted by mini-css-extract-plugin
export default {"galleryContainer":"Gallery_galleryContainer__l6GQv","imageContainer":"Gallery_imageContainer__MSTSB","galleryImage":"Gallery_galleryImage__H5rNa"};